import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import ManagerDashboardStore from 'stores/ManagerDashboardStore';
import './ManagerStrengthsAndWeaknesses.styl';
import Loading from 'components/pure/utils/Loading';
import {getManagerIdIfNotAuthUser, shouldUpdate} from 'components/StatsPage2.utils';

@connectToStores
export default class ManagerStrengthsAndWeaknesses extends React.Component {
  constructor(props) {
    super(props);
    this.scorecardOptionChange = this.scorecardOptionChange.bind(this);
    this.scoresSelectedOptionChange = this.scoresSelectedOptionChange.bind(this);
    this.callStageSelectedOptionChange = this.callStageSelectedOptionChange.bind(this);
    this.state = {
      callStage: null,
      scorecard: null,
      scoresOption: null,
    };
  }

  static getStores() {
    return [ManagerDashboardStore];
  }

  static getPropsFromStores() {
    const store = ManagerDashboardStore.getState();
    const {widgets, widgetState} = store;
    return {widgets, widgetState};
  }

  componentDidMount() {
    this.getWidget();
  }

  componentDidUpdate(prevProps) {
    if (!shouldUpdate(prevProps, this.props, this.props.useTeam)) {
      return;
    }
    const {callStage, scorecard, scoresOption} = this.state;
    this.getWidget(callStage, scorecard, scoresOption);
  }

  getWidget(callStageIn = null, scorecardIn = null, scoresOptionIn = null) {
    const {startDate, endDate, useTeam, widgetId, widgetType} = this.props;
    if (useTeam && !this.props.selectedTeam) {
      return;
    }
    const callStage = callStageIn ? callStageIn : 'ALL';
    const scorecard = scorecardIn ? scorecardIn : 'ALL';
    const scoresOption = scoresOptionIn ? scoresOptionIn : 'ALL_SCORES';
    const widgetConfig = {
      startDate: startDate,
      endDate: endDate,
      callStage: callStage,
      scorecard: scorecard,
      scoresOption: scoresOption,
      widgetId: widgetId,
      widgetType: widgetType,
    };
    if (useTeam) {
      widgetConfig.teamId = this.props.selectedTeam.id;
    }

    ManagerDashboardActions.getWidget.defer([widgetConfig, getManagerIdIfNotAuthUser(this.props)]);
  }

  callStageSelectedOptionChange(callStage) {
    this.setState({callStage: callStage}, () => {
      this.getWidget(callStage, this.state.scorecard, this.state.scoresOption);
    });
  }

  scorecardOptionChange(scorecard) {
    this.setState({scorecard: scorecard}, () => {
      this.getWidget(this.state.callStage, scorecard, this.state.scoresOption);
    });
  }

  scoresSelectedOptionChange(scoresOption) {
    this.setState({scoresOption: scoresOption}, () => {
      this.getWidget(this.state.callStage, this.state.scorecard, scoresOption);
    });
  }

  render() {
    if (!this.props.widgets) return <Loading />;

    const {widgetId} = this.props;
    const widgetState = this.props.widgetState.get(widgetId);
    const widget = this.props.widgets.get(widgetId);

    if (!widget) return <Loading />;

    return (
      <this.props.child
        key={widget.widgetId}
        widgetState={widgetState}
        managerId={getManagerIdIfNotAuthUser(this.props)}
        hidePeriod={true}
        scorecardOptionChange={this.scorecardOptionChange}
        scoresSelectedOptionChange={this.scoresSelectedOptionChange}
        callStageSelectedOptionChange={this.callStageSelectedOptionChange}
        useScorecardTabs={true}
        adminId={this.props.adminId}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        fromPath={this.props.fromPath}
        location={this.props.location}
        managerInfo={this.props.manager}
        scorecardId={this.state.scorecard}
        {...widget}
      />
    );
  }
}
